import React, { Component, useEffect, useState } from "react";
import Form from "../comman/form";
import { Modal, Button } from "react-bootstrap";
import Joi from "joi-browser";
import config from "../config.json";
import Moment from "react-moment";
import { getAlert, getConfirmAlert } from "../services/appAlerts";
import { getWfPhasesColor } from "../services/appService";
import { useDispatch, useSelector } from "react-redux";
import { getPartnerPerformers, getPartnerUsers, getRegisteredPartners, loadPartnerPerformers, loadPartnerPerformersById, loadRegisteredPartners } from "../app/store/partner";
import { getAllRolesPerformers, getAllWorkfllowRoles, getRolePerformers, loadAllWorkflowRoles, loadAllWorkflowRolesPerformers, loadRolePerformers } from "../app/store/workflowRole";
import { getTaskAssignHistory, getTaskAssignStatus, getTaskAssignHistoryLoading, getTaskReAssignLoading, loadTaskReAssignHistory, taskReAssign } from "../app/store/WorkflowEngine";
import { getCurrentUser } from "../app/store/auth";

const getPhaseIcon = (phase) => {
  switch (phase) {
    case "Approved": return "fa-check-circle";
    case "Denied": case "Rejected": return "fa-times-circle";
    case "Application": return "fa-file-text-o";
    case "Onboarding": return "fa-user-plus";
    case "Review": return "fa-check-square-o";
    case "Compliance": return "fa-shield";
    case "Time Log": return "fa-clock-o";
    case "Invoice": return "fa-file-text";
    case "Pending": return "fa-hourglass-half";
    default: return "fa-tag";
  }
};

const TaskReAssignPopup = (props) => {
  const { selectedObj, reAssignShowHide,
    handleReAssignModalShowHide, handleReAssignSubmit } = props;

  const themeClass = selectedObj
    ? (getWfPhasesColor(selectedObj.wfPhase) || "btn-default").replace("btn-", "theme-")
    : "theme-default";

  const performerTypes = [
    {
      id: "WP",
      name: "Main User",
    },
    {
      id: "PP",
      name: "Partner",
    },
  ];

  const [partners, setPartners] = useState([]);
  const [wfRoles, setWfRoles] = useState([]);
  const [partnerUsers, setPartnerUsers] = useState([]);
  const [wfUsers, setWfUsers] = useState([]);
  const [reAssignHistory, setReAssignHistory] = useState([]);
  const [performerType, setPerformerType] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [selectedPartner, setSelectedPartner] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [notes, setNotes] = useState("");
  const [selectedNotifications, setSelectedNotifications] = useState([]);
  const [selectedKey, setSelectedKey] = useState("reassign");

  const registeredPartnersSelector = useSelector(getRegisteredPartners);
  const taskAssignHistorySelector = useSelector(getTaskAssignHistory);
  const isHistoryLoading = useSelector(getTaskAssignHistoryLoading);
  const allWorkfllowRolesSelector = useSelector(getAllWorkfllowRoles);
  const rolePerformersSelector = useSelector(getRolePerformers);
  const partnerUsersSelector = useSelector(getPartnerUsers);
  const taskAssignStatusSelector = useSelector(getTaskAssignStatus);
  const isReAssignLoading = useSelector(getTaskReAssignLoading);

  const dispatch = useDispatch();
  const currentUser = getCurrentUser();

  useEffect(() => {
    dispatch(loadAllWorkflowRoles());
    dispatch(loadRegisteredPartners());
  }, []);

  useEffect(() => {
    if (selectedObj?.wiid) {
      dispatch(loadTaskReAssignHistory(selectedObj.wiid));
      setSelectedKey("reassign");
    }
  }, [selectedObj])

  useEffect(() => {
    if (taskAssignHistorySelector) setReAssignHistory(taskAssignHistorySelector);
  }, [taskAssignHistorySelector]);

  useEffect(() => {
    if (allWorkfllowRolesSelector) setWfRoles(allWorkfllowRolesSelector)
  }, [allWorkfllowRolesSelector])

  useEffect(() => {
    if (registeredPartnersSelector) setPartners(registeredPartnersSelector);
  }, [registeredPartnersSelector]);

  useEffect(() => {
    if (rolePerformersSelector) {
      setWfUsers(rolePerformersSelector.filter((e) => e.status === true));
    }
  }, [rolePerformersSelector]);

  useEffect(() => {
    if (partnerUsersSelector) setWfUsers(partnerUsersSelector);
  }, [partnerUsersSelector]);

  useEffect(() => {
    if (taskAssignStatusSelector) {
      setSelectedPartner("");
      setSelectedRole("");
      setSelectedUser("");
      setPerformerType("");
      setNotes("");
      setSelectedNotifications([])
      getAlert("", "Task Re-Assigned Successfully", "success");
      if (selectedObj?.wiid) dispatch(loadTaskReAssignHistory(selectedObj.wiid));
      handleReAssignSubmit();
    }
  }, [taskAssignStatusSelector])

  const handleRoleChange = ({ currentTarget }) => {
    setSelectedRole(currentTarget.value);
    dispatch(loadRolePerformers(currentTarget.value));
  }

  const handePartnerChange = ({ currentTarget }) => {
    setSelectedPartner(currentTarget.value);
    dispatch(loadPartnerPerformersById(currentTarget.value));
  }

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    setSelectedNotifications((prev) =>
      checked ? [...prev, value] : prev.filter((item) => item !== value)
    );
  };

  const handleSubmit = async () => {
    const frmData = new FormData();
    frmData.append("performerType", performerType);
    frmData.append("selectedUser", selectedUser);
    frmData.append("notificationType", JSON.stringify(selectedNotifications));
    frmData.append("notes", notes);
    frmData.append("addedBy", currentUser?.id);
    frmData.append("workflowTask", JSON.stringify(selectedObj));
    const result = await getConfirmAlert("Warning", "Are you sure you want to ReAssign task?", "warning");
    if (result.isConfirmed)
      dispatch(taskReAssign(frmData));
  };

  const candidateName = selectedObj?.performerName || selectedObj?.applicantName || selectedObj?.name || "";
  const email = selectedObj?.performerEmail || selectedObj?.applicantEmail || selectedObj?.email || "";
  const phone = selectedObj?.performerPhone || selectedObj?.phone || selectedObj?.cellPhone || "";
  const btnDisabled = !selectedUser || !performerType;

  if (!reAssignShowHide) return null;

  return (
    <Modal
      show={Boolean(reAssignShowHide)}
      onHide={() => !isReAssignLoading && handleReAssignModalShowHide("")}
      size="xl"
      dialogClassName={`rt-reassign-modal ${themeClass}`}
      backdrop={isReAssignLoading ? "static" : true}
      keyboard={!isReAssignLoading}
      centered
    >
      <style>{`
        /* Ensure the modal and backdrop are on top of sidebars/headers */
        .modal-backdrop {
          z-index: 1080 !important;
        }
        .modal {
          z-index: 1090 !important;
        }

        .modal-backdrop.show {
          backdrop-filter: blur(4px) !important;
          -webkit-backdrop-filter: blur(4px) !important;
          background-color: rgba(15, 23, 42, 0.3) !important;
          opacity: 1 !important;
        }

        .rt-reassign-modal {
          --task-accent: #2563eb;
          --task-soft: rgba(37, 99, 235, 0.04);
          max-width: 90% !important;
          width: 1100px !important;
        }

        .rt-reassign-modal .modal-content {
          border-radius: 0 !important;
          border: 1px solid #cbd5e1 !important;
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.05) !important;
          overflow: hidden !important;
          background: #ffffff !important;
          font-family: "Open Sans", sans-serif !important;
        }

        .rt-reassign-modal .modal-header {
          position: relative !important;
          padding: 16px 20px !important;
          background: #ffffff !important;
          border-bottom: 1px solid #e2e8f0 !important;
          border-radius: 0 !important;
        }

        .rt-reassign-modal .rt-header-shell {
          width: 100% !important;
        }

        .rt-reassign-modal .rt-header-top {
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          gap: 12px !important;
        }

        .rt-reassign-modal .rt-header-main {
          display: flex !important;
          align-items: center !important;
          gap: 12px !important;
          min-width: 0 !important;
          flex: 1 !important;
        }

        .rt-reassign-modal .rt-header-copy {
          display: flex !important;
          flex-direction: column !important;
          gap: 4px !important;
          min-width: 0 !important;
        }

        .rt-reassign-modal .rt-modal-title {
          display: inline-flex !important;
          align-items: center !important;
          margin: 0 !important;
          color: #1e293b !important;
          font-size: 18px !important;
          font-weight: 500 !important;
          line-height: 1.2 !important;
          min-width: 0 !important;
        }

        .rt-reassign-modal .rt-header-icon {
          width: 52px !important;
          height: 52px !important;
          min-height: 52px !important;
          border-radius: 0 !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: #171717 !important;
          background: #f5f5f5 !important;
          border: 1px solid #d4d4d4 !important;
          box-shadow: 0 2px 6px -2px rgba(15,23,42,0.08) !important;
          font-size: 18px !important;
          flex-shrink: 0 !important;
        }

        .rt-reassign-modal .rt-modal-title-text {
          display: inline-flex !important;
          align-items: center !important;
          gap: 12px !important;
          min-width: 0 !important;
          flex-wrap: wrap !important;
        }

        .rt-reassign-modal .rt-modal-title-badge {
          display: inline-flex !important;
          align-items: center !important;
          gap: 5px !important;
          padding: 3px 8px !important;
          height: 22px !important;
          box-sizing: border-box !important;
          border-radius: 0 !important;
          font-size: 11px !important;
          font-weight: 600 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.02em !important;
          background: #171717 !important;
          color: #ffffff !important;
          border: 1px solid #171717 !important;
          line-height: 1 !important;
        }
        .rt-reassign-modal .rt-modal-title-badge i {
          font-size: 10.5px !important;
        }
        .rt-reassign-modal .rt-modal-title-badge.btn-primary { background: #eff6ff !important; color: #2563eb !important; border-color: #bfdbfe !important; }
        .rt-reassign-modal .rt-modal-title-badge.btn-info { background: #ecfeff !important; color: #0891b2 !important; border-color: #a5f3fc !important; }
        .rt-reassign-modal .rt-modal-title-badge.btn-warning { background: #fffbeb !important; color: #d97706 !important; border-color: #fde68a !important; }
        .rt-reassign-modal .rt-modal-title-badge.btn-success { background: #f0fdf4 !important; color: #16a34a !important; border-color: #bbf7d0 !important; }
        .rt-reassign-modal .rt-modal-title-badge.btn-wf2-default { background: #fef9c3 !important; color: #ca8a04 !important; border-color: #fef08a !important; }
        .rt-reassign-modal .rt-modal-title-badge.btn-wf3-default { background: #ecfdf5 !important; color: #059669 !important; border-color: #a7f3d0 !important; }
        .rt-reassign-modal .rt-modal-title-badge.btn-wf4-default { background: #fef2f2 !important; color: #dc2626 !important; border-color: #fecaca !important; }
        .rt-reassign-modal .rt-modal-title-badge.btn-wf5-default { background: #fff7ed !important; color: #ea580c !important; border-color: #fed7aa !important; }
        .rt-reassign-modal .rt-modal-title-badge.btn-wf6-default { background: #f5f3ff !important; color: #7c3aed !important; border-color: #ddd6fe !important; }
        .rt-reassign-modal .rt-modal-title-badge.btn-default,
        .rt-reassign-modal .rt-modal-title-badge.btn-wf-default { background: #f1f5f9 !important; color: #475569 !important; border-color: #cbd5e1 !important; }

        .rt-reassign-modal .rt-modal-meta-row {
          display: flex !important;
          align-items: center !important;
          flex-wrap: wrap !important;
          gap: 8px !important;
          margin-top: 0 !important;
          padding-left: 0 !important;
          font-size: 12px !important;
          font-weight: 400 !important;
          color: #64748b !important;
        }

        .rt-meta-chip {
          display: inline-flex !important;
          align-items: center !important;
          gap: 4px !important;
          background: #ffffff !important;
          padding: 3px 9px !important;
          height: 24px !important;
          min-height: 24px !important;
          box-sizing: border-box !important;
          border-radius: 0 !important;
          font-size: 11.5px !important;
          font-weight: 500 !important;
          color: #0f172a !important;
          border: 1px solid #cbd5e1 !important;
          box-shadow: none !important;
          line-height: 1 !important;
        }

        .rt-meta-chip i {
          font-size: 11.5px !important;
          margin-right: 5px !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
        }
        .rt-meta-chip i.fa-user { color: #9333ea !important; }
        .rt-meta-chip i.fa-envelope, .rt-meta-chip i.fa-envelope-o { color: #0284c7 !important; }
        .rt-meta-chip i.fa-phone { color: #16a34a !important; }
        .rt-meta-chip i.fa-tasks, .rt-meta-chip i.fa-database { color: #2563eb !important; }
        .rt-meta-chip i.fa-info-circle { color: #0891b2 !important; }
        .rt-meta-chip i.fa-id-badge { color: #6366f1 !important; }
        .rt-meta-chip i.fa-hashtag { color: #d97706 !important; }

        .rt-reassign-modal .rt-action-btn {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 32px !important;
          height: 32px !important;
          padding: 0 !important;
          font-size: 13.5px !important;
          font-weight: 500 !important;
          color: #64748b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          cursor: pointer !important;
          transition: all 0.15s ease !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
          outline: none !important;
          font-family: inherit !important;
        }
        .rt-reassign-modal .rt-action-btn:hover {
          color: #dc2626 !important;
          border-color: #fca5a5 !important;
          background: #fef2f2 !important;
          transform: translateY(-1px) !important;
        }

        .rt-reassign-modal .modal-footer {
          background: #ffffff !important;
          border-top: 1px solid #e2e8f0 !important;
          padding: 14px 20px !important;
          display: flex !important;
          justify-content: flex-end !important;
          gap: 10px !important;
        }
        .rt-reassign-modal .wf-modal-footer-close-btn {
          display: inline-flex !important;
          align-items: center !important;
          gap: 4px !important;
          padding: 7px 18px !important;
          font-size: 13.5px !important;
          font-weight: 500 !important;
          color: #1e293b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
          outline: none !important;
          cursor: pointer !important;
          transition: all 0.15s ease !important;
          font-family: inherit !important;
        }
        .rt-reassign-modal .wf-modal-footer-close-btn:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          transform: translateY(-1px) !important;
        }

        .rt-reassign-modal .modal-body {
          padding: 20px !important;
          background: #ffffff !important;
          max-height: calc(100vh - 180px) !important;
          overflow-y: auto !important;
        }

        .rt-msg-table-scroll {
          overflow: auto !important;
          max-height: 400px !important;
          position: relative !important;
          scrollbar-width: thin !important;
          scrollbar-color: #94a3b8 #f1f5f9 !important;
          border-radius: 0 !important;
          border: none !important;
        }

        .rt-msg-table {
          width: 100%;
          margin-bottom: 0;
          border: none;
          border-collapse: separate;
          border-spacing: 0;
          color: #1e293b;
        }
        .rt-msg-table thead {
          position: sticky;
          top: 0;
          z-index: 2;
          background: #f8fafc;
        }
        .rt-msg-table thead th {
          color: #64748b;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.05em;
          text-transform: uppercase;
          padding: 12px 16px;
          border-top: none;
          border-bottom: 1px solid #cbd5e1;
          white-space: nowrap;
          font-family: inherit !important;
        }
        .rt-reassign-modal .rt-msg-table td {
          padding: 12px 16px;
          font-size: 13.5px;
          color: #1e293b;
          vertical-align: top !important;
          border-top: none;
          border-bottom: 1px solid #e2e8f0;
          background: transparent !important;
          transition: all 0.15s ease;
          font-family: inherit !important;
        }
        .rt-reassign-modal .rt-msg-table tbody tr:last-child td {
          border-bottom: none;
        }
        .rt-reassign-modal .rt-msg-table tbody tr.rt-msg-row-static:hover td {
          background-color: #f8fafc !important;
        }

        .wf-name-cell {
          display: flex !important;
          align-items: flex-start !important;
          gap: 10px !important;
          min-width: 150px !important;
        }
        .wf-name-avatar {
          width: 32px !important;
          height: 32px !important;
          border-radius: 0 !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          background: #f5f5f5 !important;
          border: 1px solid #d4d4d4 !important;
          color: #1e293b !important;
          font-size: 12px !important;
          font-weight: 500 !important;
          flex-shrink: 0 !important;
        }
        .wf-name-meta {
          display: flex !important;
          flex-direction: column !important;
          gap: 1px !important;
          min-width: 0 !important;
        }
        .wf-name-main {
          font-weight: 400 !important;
          color: #1e293b !important;
          font-size: 13.5px !important;
          line-height: 1.2 !important;
        }
        .wf-name-title {
          font-size: 12px !important;
          color: #64748b !important;
          font-weight: 400 !important;
          line-height: 1.2 !important;
        }
        .wf-empty-value {
          color: #64748b !important;
          font-size: 12px !important;
          font-weight: 400 !important;
          line-height: 1.2 !important;
        }

        .rt-msg-time {
          display: inline-flex;
          flex-direction: column;
          gap: 2px;
          font-size: 13px;
          color: #1e293b;
          font-weight: 400;
          white-space: nowrap;
        }

        .rt-reassign-save-btn {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          background: #2563eb !important;
          border: 1px solid #2563eb !important;
          padding: 7px 18px !important;
          border-radius: 0 !important;
          font-size: 13.5px !important;
          font-weight: 500 !important;
          color: #ffffff !important;
          cursor: pointer !important;
          transition: all 0.15s ease !important;
          outline: none !important;
          white-space: nowrap !important;
          font-family: inherit !important;
          box-shadow: 0 2px 5px rgba(37, 99, 235, 0.2) !important;
        }
        .rt-reassign-save-btn:hover:not(:disabled) {
          background: #1d4ed8 !important;
          border-color: #1d4ed8 !important;
          transform: translateY(-1px) !important;
        }
        .rt-reassign-save-btn:disabled {
          opacity: 0.5 !important;
          cursor: not-allowed !important;
          transform: none !important;
        }
        
        .rt-reassign-modal label.form-control-label {
          font-size: 11.5px !important;
          font-weight: 700 !important;
          color: #475569 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.03em !important;
          margin-bottom: 6px !important;
        }
        
        .rt-reassign-modal input[type="text"],
        .rt-reassign-modal select,
        .rt-reassign-modal textarea,
        .rt-reassign-modal .form-control {
          font-size: 13px !important;
          color: #1e293b !important;
          background-color: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          padding: 7px 10px !important;
          box-shadow: 0 1px 2px rgba(15,23,42,0.04) !important;
          transition: border-color 0.15s ease, box-shadow 0.15s ease !important;
          outline: none !important;
          font-family: inherit !important;
        }
        .rt-reassign-modal input:focus,
        .rt-reassign-modal select:focus,
        .rt-reassign-modal textarea:focus,
        .rt-reassign-modal .form-control:focus {
          border-color: #2563eb !important;
          box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12) !important;
          outline: none !important;
        }

        .rt-msg-tab-bar {
          display: flex !important;
          align-items: stretch !important;
          gap: 4px !important;
          margin-bottom: 16px !important;
          padding: 8px 0 0 !important;
          position: relative !important;
          border: 0 !important;
          border-bottom: 2px solid #e5e5e5 !important;
          background: #ffffff !important;
        }

        .rt-msg-tab-btn {
          position: relative !important;
          display: inline-flex !important;
          align-items: center !important;
          gap: 7px !important;
          padding: 9px 16px 11px !important;
          border: 0 !important;
          border-radius: 0 !important;
          outline: none !important;
          background: transparent !important;
          color: #1e293b !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          line-height: normal !important;
          white-space: nowrap !important;
          box-shadow: none !important;
          cursor: pointer !important;
          transition: color 0.2s ease, background 0.2s ease !important;
        }
        .rt-msg-tab-btn i {
          color: currentColor !important;
          font-size: 14px !important;
        }
        .rt-msg-tab-btn:hover {
          color: #0f172a !important;
          background: #f5f5f5 !important;
        }
        .rt-msg-tab-btn:focus,
        .rt-msg-tab-btn:focus-visible,
        .rt-msg-tab-btn:active {
          border-color: transparent !important;
          outline: none !important;
          box-shadow: none !important;
        }
        .rt-msg-tab-btn.active {
          color: #ffffff !important;
          background: #171717 !important;
          font-weight: 500 !important;
        }
        .rt-msg-tab-btn.active i {
          color: #ffffff !important;
        }
        .rt-msg-tab-btn::after,
        .rt-msg-tab-btn.active::after {
          bottom: -2px !important;
          height: 2px !important;
          border-radius: 0 !important;
          background: #171717 !important;
          transform: scaleX(0) !important;
        }
        .rt-msg-tab-badge {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          min-width: 20px !important;
          height: 20px !important;
          padding: 0 6px !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 0 !important;
          background: #f1f5f9 !important;
          color: #1e293b !important;
          font-size: 12px !important;
          font-weight: 600 !important;
          line-height: 1 !important;
          box-shadow: none !important;
        }
        .rt-msg-tab-btn.active .rt-msg-tab-badge {
          border-color: #ffffff !important;
          background: #ffffff !important;
          color: #171717 !important;
        }

        .wf-table-empty {
          position: relative !important;
          display: flex !important;
          flex-direction: column !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 56px 24px 48px !important;
          text-align: center !important;
          overflow: hidden !important;
          background: #ffffff !important;
          border-radius: 16px !important;
          margin: 12px !important;
          border: 1.5px solid rgba(37,99,235,0.08) !important;
        }

        .wf-te-icon-wrap {
          position: relative !important;
          width: 80px !important;
          height: 80px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          margin-bottom: 24px !important;
          z-index: 1 !important;
        }

        .wf-te-icon {
          width: 72px !important;
          height: 72px !important;
          border-radius: 16px !important;
          background: #f8fafc !important;
          border: 1.5px solid #e2e8f0 !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          font-size: 28px !important;
          color: #94a3b8 !important;
          position: relative !important;
          z-index: 2 !important;
        }

        .wf-te-title {
          font-size: 14px !important;
          font-weight: 500 !important;
          color: #1e293b !important;
          margin: 0 0 10px 0 !important;
          line-height: 1.3 !important;
        }

        .wf-te-desc {
          font-size: 14px !important;
          font-weight: 400 !important;
          color: #64748b !important;
          margin: 0 !important;
          line-height: 1.65 !important;
        }

        .rt-form-section {
          margin-bottom: 20px !important;
        }
        .rt-section-header {
          display: flex !important;
          align-items: center !important;
          gap: 8px !important;
          margin-bottom: 12px !important;
          padding-bottom: 6px !important;
          border-bottom: 1px solid #e2e8f0 !important;
        }
        .rt-section-title {
          font-size: 12px !important;
          font-weight: 700 !important;
          color: #334155 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.04em !important;
          margin: 0 !important;
        }
        .rt-section-desc {
          font-size: 12px !important;
          color: #64748b !important;
          font-weight: 400 !important;
          margin-left: auto !important;
          text-transform: none !important;
        }

        .rt-perf-type-cards {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 14px;
          margin-top: 4px;
        }

        .rt-perf-type-card {
          position: relative;
          display: flex;
          align-items: center;
          gap: 14px;
          padding: 16px 20px;
          background: #ffffff;
          border: 1px solid #cbd5e1;
          border-radius: 0;
          cursor: pointer;
          transition: all 0.15s ease;
          box-shadow: 0 1px 2px rgba(15,23,42,0.04);
          user-select: none;
        }
        .rt-perf-type-card:hover {
          border-color: #94a3b8;
          background: #f8fafc;
          transform: translateY(-1px);
        }
        .rt-perf-type-card.active {
          border-color: #2563eb;
          background: #eff6ff;
          box-shadow: 0 0 0 1px #2563eb;
        }

        .rt-ptc-icon-wrap {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 38px;
          height: 38px;
          border-radius: 0;
          background: #f8fafc;
          border: 1px solid #cbd5e1;
          color: #64748b;
          font-size: 16px;
          transition: all 0.15s ease;
          flex-shrink: 0;
        }
        .rt-perf-type-card.active .rt-ptc-icon-wrap {
          background: #ffffff;
          border-color: #2563eb;
          color: #2563eb;
        }

        .rt-ptc-content {
          display: flex;
          flex-direction: column;
          gap: 2px;
          min-width: 0;
        }
        .rt-ptc-title {
          font-size: 14px;
          font-weight: 700;
          color: #1e293b;
        }
        .rt-ptc-desc {
          font-size: 12px;
          color: #64748b;
          line-height: 1.3;
        }

        .rt-ptc-badge {
          position: absolute;
          top: 10px;
          right: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 18px;
          height: 18px;
          border-radius: 0;
          background: #2563eb;
          color: #ffffff;
          font-size: 10px;
        }

        .rt-assignment-card {
          background: #ffffff;
          border: 1px solid #cbd5e1;
          border-radius: 0;
          padding: 16px 20px;
          box-shadow: 0 1px 2px rgba(15,23,42,0.04) !important;
        }

        .rt-assignment-placeholder {
          border: 1px dashed #cbd5e1 !important;
          border-radius: 0 !important;
          padding: 20px !important;
          text-align: center !important;
          color: #64748b !important;
          background: #f8fafc !important;
        }
        .rt-assignment-placeholder i {
          font-size: 20px !important;
          color: #94a3b8 !important;
          margin-bottom: 6px !important;
        }
        .rt-assignment-placeholder p {
          font-size: 12.5px !important;
          font-weight: 500 !important;
          margin: 0 !important;
        }

        .rt-select-help-text {
          font-size: 11.5px !important;
          color: #64748b !important;
          margin-top: 4px !important;
          display: block !important;
          font-weight: 400 !important;
        }

        .rt-notif-cards-grid {
          display: grid !important;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)) !important;
          gap: 12px !important;
          margin-top: 4px !important;
        }
        .rt-notif-card {
          position: relative !important;
          display: flex !important;
          align-items: center !important;
          justify-content: space-between !important;
          gap: 14px !important;
          padding: 12px 16px !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          cursor: pointer !important;
          transition: all 0.15s ease !important;
          user-select: none !important;
          box-shadow: 0 1px 2px rgba(15,23,42,0.04) !important;
        }
        .rt-notif-card:hover {
          border-color: #94a3b8 !important;
          background: #f8fafc !important;
          transform: translateY(-1px) !important;
        }
        .rt-notif-card.active {
          border-color: #2563eb !important;
          background: #eff6ff !important;
          box-shadow: 0 0 0 1px #2563eb !important;
        }
        .rt-notif-card-main {
          display: flex !important;
          align-items: center !important;
          gap: 12px !important;
          min-width: 0 !important;
          flex: 1 1 auto !important;
        }
        .rt-notif-card-icon {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 34px !important;
          height: 34px !important;
          border-radius: 0 !important;
          background: #f8fafc;
          border: 1px solid #cbd5e1;
          color: #64748b;
          font-size: 14px;
          transition: all 0.15s ease;
          flex-shrink: 0;
        }
        .rt-notif-card.active .rt-notif-card-icon {
          background: #ffffff !important;
          border-color: #2563eb !important;
          color: #2563eb !important;
        }
        .rt-notif-card-info {
          display: flex !important;
          flex-direction: column !important;
          gap: 1px !important;
          min-width: 0 !important;
        }
        .rt-notif-card-title {
          font-size: 13px !important;
          font-weight: 700 !important;
          color: #1e293b !important;
          line-height: 1.2 !important;
        }
        .rt-notif-card-desc {
          font-size: 11.5px !important;
          color: #64748b !important;
          line-height: 1.3 !important;
        }
        .rt-notif-card.active .rt-notif-card-desc {
          color: #475569 !important;
        }
        .rt-notif-card-toggle {
          position: relative !important;
          width: 34px !important;
          height: 18px !important;
          background: #cbd5e1 !important;
          border-radius: 0 !important;
          transition: background 0.2s ease !important;
          flex-shrink: 0 !important;
        }
        .rt-notif-card.active .rt-notif-card-toggle {
          background: #2563eb !important;
        }
        .rt-toggle-slider {
          position: absolute !important;
          top: 2px !important;
          left: 2px !important;
          width: 14px !important;
          height: 14px !important;
          background: #ffffff !important;
          border-radius: 0 !important;
          transition: transform 0.2s ease !important;
        }
        .rt-notif-card.active .rt-toggle-slider {
          transform: translateX(16px) !important;
        }

        .rt-quick-tags-container {
          display: flex !important;
          flex-wrap: wrap !important;
          gap: 4px !important;
          margin-bottom: 10px !important;
          align-items: center !important;
        }
        .rt-quick-tag-label {
          font-size: 11px !important;
          font-weight: 700 !important;
          color: #64748b !important;
          text-transform: uppercase !important;
          letter-spacing: 0.03em !important;
          margin-right: 4px !important;
        }
        .rt-quick-tag-badge {
          display: inline-flex !important;
          align-items: center !important;
          padding: 4px 8px !important;
          border-radius: 0 !important;
          font-size: 12px !important;
          font-weight: 500 !important;
          color: #475569 !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          cursor: pointer !important;
          transition: all 0.15s ease !important;
          user-select: none !important;
        }
        .rt-quick-tag-badge:hover {
          color: #2563eb !important;
          border-color: #2563eb !important;
          background: #eff6ff !important;
          transform: translateY(-1px) !important;
        }
      `}</style>

      <Modal.Header>
        <div className="rt-header-shell">
          <div className="rt-header-top">
            <div className="rt-header-main">
              <i className="rt-header-icon fa fa-share" aria-hidden="true" />
              <div className="rt-header-copy">
                <h2 className="rt-modal-title">
                  <span className="rt-modal-title-text">
                    <span>Re-Assign Task</span>
                    {selectedObj?.wfPhase && (
                      <span className="rt-modal-title-badge">
                        {selectedObj.wfPhase}
                      </span>
                    )}
                  </span>
                </h2>
                <div className="rt-modal-meta-row">
                  {candidateName && (
                    <span className="rt-meta-chip">
                      <i className="fa fa-user" aria-hidden="true" style={{ color: "#9333ea", marginRight: "4px" }} />
                      <span>{candidateName}</span>
                    </span>
                  )}
                  {email && (
                    <span className="rt-meta-chip">
                      <i className="fa fa-envelope" aria-hidden="true" style={{ color: "#0284c7", marginRight: "4px" }} />
                      <span>{email}</span>
                    </span>
                  )}
                  {phone && (
                    <span className="rt-meta-chip">
                      <i className="fa fa-phone" aria-hidden="true" style={{ color: "#16a34a", marginRight: "4px" }} />
                      <span>{phone}</span>
                    </span>
                  )}
                  <span className="rt-meta-chip">
                    <i className="fa fa-tasks" aria-hidden="true" style={{ color: "#2563eb", marginRight: "4px" }} />
                    <span>Process ID: {selectedObj?.ciid || "N/A"}</span>
                  </span>
                  <span className="rt-meta-chip">
                    <i className="fa fa-info-circle" aria-hidden="true" style={{ color: "#0891b2", marginRight: "4px" }} />
                    <span>Task: {selectedObj?.itemName || "N/A"}</span>
                  </span>
                </div>
              </div>
            </div>
            <button
              type="button"
              className="rt-action-btn"
              onClick={() => handleReAssignModalShowHide("")}
              disabled={isReAssignLoading}
              title="Close"
            >
              <i className="fa fa-times" aria-hidden="true" />
            </button>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body>
        <div className="rt-msg-tab-bar">
          <button
            type="button"
            className={`rt-msg-tab-btn${selectedKey === "reassign" ? " active" : ""}`}
            onClick={() => setSelectedKey("reassign")}
          >
            <i className="fa fa-share" aria-hidden="true" />
            Re-Assign Form
          </button>
          <button
            type="button"
            className={`rt-msg-tab-btn${selectedKey === "history" ? " active" : ""}`}
            onClick={() => setSelectedKey("history")}
          >
            <i className="fa fa-history" aria-hidden="true" />
            Routing History
            <span className="rt-msg-tab-badge">{reAssignHistory.length}</span>
          </button>
        </div>

        {selectedKey === "reassign" && (
          <div className="rt-msg-panel">
            <div className="row">
              {/* Step 1: Performer Type */}
              <div className="col-md-12 rt-form-section">
                <div className="rt-section-header">
                  <h4 className="rt-section-title">1. Performer Type</h4>
                  <span className="rt-section-desc">Select internal staff or external partner</span>
                </div>
                <div className="rt-perf-type-cards">
                  <div
                    className={`rt-perf-type-card${performerType === "WP" ? " active" : ""}`}
                    onClick={() => {
                      setPerformerType("WP");
                      setSelectedRole("");
                      setSelectedPartner("");
                      setSelectedUser("");
                    }}
                  >
                    <div className="rt-ptc-icon-wrap">
                      <i className="fa fa-user-circle-o" aria-hidden="true" />
                    </div>
                    <div className="rt-ptc-content">
                      <span className="rt-ptc-title">Main User</span>
                      <span className="rt-ptc-desc">Assign to an internal staff member or system role</span>
                    </div>
                    {performerType === "WP" && (
                      <div className="rt-ptc-badge">
                        <i className="fa fa-check" aria-hidden="true" />
                      </div>
                    )}
                  </div>

                  <div
                    className={`rt-perf-type-card${performerType === "PP" ? " active" : ""}`}
                    onClick={() => {
                      setPerformerType("PP");
                      setSelectedRole("");
                      setSelectedPartner("");
                      setSelectedUser("");
                    }}
                  >
                    <div className="rt-ptc-icon-wrap">
                      <i className="fa fa-handshake-o" aria-hidden="true" />
                    </div>
                    <div className="rt-ptc-content">
                      <span className="rt-ptc-title">External Partner</span>
                      <span className="rt-ptc-desc">Assign to a subcontractor or external vendor partner</span>
                    </div>
                    {performerType === "PP" && (
                      <div className="rt-ptc-badge">
                        <i className="fa fa-check" aria-hidden="true" />
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Step 2: Assignment Details */}
              <div className="col-md-12 rt-form-section">
                <div className="rt-section-header">
                  <h4 className="rt-section-title">2. Assignment Details</h4>
                  {performerType && (
                    <span className="rt-section-desc">
                      {performerType === "WP" ? "Internal Routing Active" : "External Partner Routing Active"}
                    </span>
                  )}
                </div>

                {performerType ? (
                  <div className="row">
                    {performerType === "WP" && (
                      <div className="col-md-6 form-group">
                        <label htmlFor="selectedRole" className="form-control-label">
                          Select Role
                        </label>
                        <select
                          className="form-control"
                          id="selectedRole"
                          name="selectedRole"
                          value={selectedRole}
                          onChange={handleRoleChange}
                        >
                          <option value="">Select Role</option>
                          {wfRoles.map((p) => (
                            <option key={p.roleid} value={p.roleid}>{p.rolename}</option>
                          ))}
                        </select>
                      </div>
                    )}

                    {performerType === "PP" && (
                      <div className="col-md-6 form-group">
                        <label htmlFor="selectedPartner" className="form-control-label">
                          Select Partner
                        </label>
                        <select
                          name="selectedPartner"
                          id="selectedPartner"
                          className="form-control"
                          value={selectedPartner}
                          onChange={handePartnerChange}
                        >
                          <option value="">Select Partner</option>
                          {partners.map((p) => (
                            <option key={p.fuid} value={p.fuid}>
                              {p.label} (ID: {p.fuid})
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                    <div className="col-md-6 form-group">
                      <label htmlFor="selectedUser" className="form-control-label">
                        Select Assignee {wfUsers.length > 0 && `(${wfUsers.length} available)`}
                      </label>
                      <select
                        className="form-control"
                        id="selectedUser"
                        name="selectedUser"
                        value={selectedUser}
                        onChange={({ currentTarget }) => setSelectedUser(currentTarget.value)}
                      >
                        <option value="">Select Assignee</option>
                        {wfUsers.map((p) => (
                          <option key={p.id} value={p.id}>
                            {p.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                ) : (
                  <div className="rt-assignment-placeholder">
                    <i className="fa fa-arrow-circle-up" aria-hidden="true" />
                    <p>Select a performer type above to configure assignee options.</p>
                  </div>
                )}
              </div>

              {/* Step 3: Notification Preferences */}
              <div className="col-md-12 rt-form-section">
                <div className="rt-section-header">
                  <h4 className="rt-section-title">3. Notification Preferences</h4>
                </div>
                <div className="rt-notif-cards-grid">
                  <div
                    className={`rt-notif-card${selectedNotifications.includes("Text") ? " active" : ""}`}
                    onClick={() => {
                      const value = "Text";
                      setSelectedNotifications((prev) =>
                        prev.includes(value) ? prev.filter((item) => item !== value) : [...prev, value]
                      );
                    }}
                  >
                    <div className="rt-notif-card-main">
                      <div className="rt-notif-card-icon">
                        <i className="fa fa-envelope-o" aria-hidden="true" />
                      </div>
                      <div className="rt-notif-card-info">
                        <span className="rt-notif-card-title">Email Alert</span>
                      </div>
                    </div>
                    <div className="rt-notif-card-toggle">
                      <span className="rt-toggle-slider" />
                    </div>
                  </div>

                  <div
                    className={`rt-notif-card${selectedNotifications.includes("Mobile") ? " active" : ""}`}
                    onClick={() => {
                      const value = "Mobile";
                      setSelectedNotifications((prev) =>
                        prev.includes(value) ? prev.filter((item) => item !== value) : [...prev, value]
                      );
                    }}
                  >
                    <div className="rt-notif-card-main">
                      <div className="rt-notif-card-icon">
                        <i className="fa fa-mobile" aria-hidden="true" style={{ fontSize: "16px" }} />
                      </div>
                      <div className="rt-notif-card-info">
                        <span className="rt-notif-card-title">Mobile Push</span>
                      </div>
                    </div>
                    <div className="rt-notif-card-toggle">
                      <span className="rt-toggle-slider" />
                    </div>
                  </div>

                  <div
                    className={`rt-notif-card${selectedNotifications.includes("System") ? " active" : ""}`}
                    onClick={() => {
                      const value = "System";
                      setSelectedNotifications((prev) =>
                        prev.includes(value) ? prev.filter((item) => item !== value) : [...prev, value]
                      );
                    }}
                  >
                    <div className="rt-notif-card-main">
                      <div className="rt-notif-card-icon">
                        <i className="fa fa-bell-o" aria-hidden="true" />
                      </div>
                      <div className="rt-notif-card-info">
                        <span className="rt-notif-card-title">System Notice</span>
                      </div>
                    </div>
                    <div className="rt-notif-card-toggle">
                      <span className="rt-toggle-slider" />
                    </div>
                  </div>
                </div>
              </div>

              {/* Step 4: Re-Assignment Notes */}
              <div className="col-md-12 rt-form-section mb-0">
                <div className="rt-section-header">
                  <h4 className="rt-section-title">4. Re-Assignment Notes</h4>
                  <span className="rt-section-desc">Provide context or explanation for routing</span>
                </div>

                <div className="rt-quick-tags-container">
                  <span className="rt-quick-tag-label">Quick Notes:</span>
                  <div
                    className="rt-quick-tag-badge"
                    onClick={() => setNotes("Urgent Review: Please take action.")}
                  >
                    Urgent Review
                  </div>
                  <div
                    className="rt-quick-tag-badge"
                    onClick={() => setNotes("OOF Coverage: Covering while out of office.")}
                  >
                    OOF Coverage
                  </div>
                  <div
                    className="rt-quick-tag-badge"
                    onClick={() => setNotes("Shift Handover: Re-assigned for next shift.")}
                  >
                    Shift Handover
                  </div>
                  <div
                    className="rt-quick-tag-badge"
                    onClick={() => setNotes("Re-routing: Transferring to designated performer.")}
                  >
                    Re-routing
                  </div>
                </div>

                <textarea
                  cols="3"
                  rows="3"
                  id="notes"
                  className="form-control"
                  placeholder="Provide details about why this task is being re-assigned..."
                  value={notes}
                  onChange={({ currentTarget }) => setNotes(currentTarget.value)}
                  style={{ minHeight: "80px", resize: "vertical", width: "100%" }}
                />
              </div>
            </div>
          </div>
        )}

        {selectedKey === "history" && (
          <div className="rt-msg-panel">
            <div className="row">
              <div className="col-md-12">
                {isHistoryLoading ? (
                  <div className="table-responsive rt-msg-table-scroll">
                    <table className="table align-items-center table-flush rt-msg-table">
                      <thead>
                        <tr style={{ height: "0px", padding: 0 }}>
                          <th colSpan={6} style={{ padding: 0, border: "none", height: "0px", position: "relative" }}>
                            <div className="wf-loading-bar" />
                          </th>
                        </tr>
                        <tr>
                          <th>ID</th>
                          <th>Date & Time</th>
                          <th>Assigned By</th>
                          <th>Route From</th>
                          <th>Route To</th>
                          <th>Notes</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.from({ length: 3 }).map((_, i) => (
                          <tr key={`skel-${i}`} className="skeleton-row">
                            <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                            <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.06}s` }} /></td>
                            <td><span className="skeleton-cell sk-long" style={{ animationDelay: `${i * 0.07}s` }} /></td>
                            <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.08}s` }} /></td>
                            <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.06}s` }} /></td>
                            <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : reAssignHistory.length === 0 ? (
                  <div className="wf-table-empty">
                    <div className="wf-te-icon-wrap">
                      <div className="wf-te-icon">
                        <i className="fa fa-history" aria-hidden="true" />
                      </div>
                    </div>
                    <h3 className="wf-te-title">No Routing History</h3>
                    <p className="wf-te-desc">There is currently no assignment history available for this task.</p>
                  </div>
                ) : (
                  <div className="table-responsive rt-msg-table-scroll">
                    <table className="table align-items-center table-flush rt-msg-table">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Date & Time</th>
                          <th>Assigned By</th>
                          <th>Route From</th>
                          <th>Route To</th>
                          <th>Notes</th>
                        </tr>
                      </thead>
                      <tbody>
                        {reAssignHistory.map((item, idx) => {
                          const avatarText = (item.createdBy || "?").split(" ").map(n => n[0]).join("").slice(0, 2).toUpperCase();
                          return (
                            <tr key={idx} className="rt-msg-row-static">
                              <td>
                                <span style={{ fontWeight: 600, color: "#64748b", fontSize: "12px" }}>
                                  #{idx + 1}
                                </span>
                              </td>
                              <td>
                                <span className="rt-msg-time">
                                  <span><Moment format="MMM D, YYYY">{item.assignDateTime}</Moment></span>
                                  <span style={{ fontSize: "12px", color: "#64748b" }}><Moment format="h:mm a">{item.assignDateTime}</Moment></span>
                                </span>
                              </td>
                              <td>
                                <div className="wf-name-cell">
                                  <span className="wf-name-avatar">
                                    {avatarText}
                                  </span>
                                  <div className="wf-name-meta">
                                    <span className="wf-name-main">{item.createdBy || "System"}</span>
                                    <span className="wf-name-title">{item.createdUserType}</span>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <span className="rt-routing-performer is-from" style={{ fontWeight: 600, color: "#475569" }}>
                                  {item.fromPerformerName || "Unassigned"}
                                </span>
                              </td>
                              <td>
                                <span className="rt-routing-performer is-to" style={{ fontWeight: 700, color: "var(--task-accent, #2563eb)" }}>
                                  {item.toPerformerName}
                                </span>
                              </td>
                              <td style={{ maxWidth: "250px", whiteSpace: "normal", wordBreak: "break-word" }}>
                                {item.createdNotes ? (
                                  <span style={{ fontSize: "12.5px", color: "#475569" }}>
                                    {item.createdNotes}
                                  </span>
                                ) : (
                                  <span className="wf-empty-value">No notes</span>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

      </Modal.Body>

      <Modal.Footer>
        <button
          type="button"
          className="wf-modal-footer-close-btn"
          onClick={() => handleReAssignModalShowHide("")}
          disabled={isReAssignLoading}
        >
          <i className="fa fa-times" aria-hidden="true" /> Close
        </button>
        {selectedKey === "reassign" && (
          <button
            type="button"
            className="btn btn-sm btn-primary rt-reassign-save-btn"
            disabled={btnDisabled || isReAssignLoading}
            onClick={handleSubmit}
          >
            {isReAssignLoading ? (
              <>
                <i className="fa fa-spinner fa-spin mr-2" aria-hidden="true" /> Re-Assigning...
              </>
            ) : (
              <>
                <i className="fa fa-check mr-2" aria-hidden="true" /> Re-Assign Task
              </>
            )}
          </button>
        )}
      </Modal.Footer>
    </Modal>
  );
}

export default TaskReAssignPopup;
